import { AGI_DODGE_COEF, BASE_DAMAGE, BASE_DODGE, DODGE_CAP, STR_COEF } from '../data/constants';

export function computeBaseDamage(strength: number): number {
  return BASE_DAMAGE * (1 + strength * STR_COEF);
}

export function computeDodgeChance(agility: number): number {
  return Math.min(BASE_DODGE + agility * AGI_DODGE_COEF, DODGE_CAP);
}

export function computeMaxHP(health: number, baseHP: number, hpPerPoint: number): number {
  return baseHP + health * hpPerPoint;
}
